<template>
  <div class="modal support-email animated fadeIn">
    <div class="modal-background"></div>
    <div class="modal-card animated fadeInUp">
      <header class="modal-card-head">
        <span class="close-modal" @click="closeModal()">
          <i class="icon icon-close"></i>
        </span>
        <p class="modal-card-title">{{ $t('support_modal.title') }}</p>
      </header>
      <section class="modal-card-body">
        <form class="form-horizontal p-b-none m-b-none" role="form">
          <!-- From -->
          <div class="full">
            <div class="float-label">
              <input id="support-from" type="text" v-model="supportForm.from" required>
              <label for="support-from">E-mail Address</label>
              <span class="help-block" v-show="supportForm.errors.has('from')">
                {{ supportForm.errors.get('from') }}
              </span>
            </div>
          </div>

          <!-- Subject -->
          <div class="full">
            <div class="float-label">
              <input id="support-subject" type="text" v-model="supportForm.subject" required>
              <label for="support-subject">Subject</label>

              <span class="help-block" v-show="supportForm.errors.has('subject')">
                {{ supportForm.errors.get('subject') }}
              </span>
            </div>
          </div>

          <!-- Message -->
          <div class="full">
            <div class="float-label">
              <textarea rows="7" v-model="supportForm.message" placeholder="Message"></textarea>

              <span class="help-block" v-show="supportForm.errors.has('message')">
                {{ supportForm.errors.get('message') }}
              </span>
            </div>
          </div>
        </form>
      </section>
      <footer class="modal-card-foot">
        <a class="button is-primary is-large" @click.prevent="sendSupportRequest" :disabled="supportForm.busy">
          <i class="fa fa-btn fa-paper-plane"></i> Send
        </a>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  props: ["options"],

  data() {
    return {
      Events: window.Events,
      supportForm: {
        errors: {
          has: () => {},
          get: () => {}
        }
      }
    };
  },
  mounted() {
    this.supportForm = this.options.supportForm;
    this.supportForm.from = Spark.state.user.email;
  },
  methods: {
    closeModal() {
      this.supportForm.subject = '';
      this.supportForm.message = '';
      this.Events.$emit("modalClose", "supportFormModal");
    },

    /**
     * Send a customer support request.
     */
    sendSupportRequest() {
      Spark.post('/support/email', this.supportForm)
        .then(() => {
          (new Notyf()).confirm('We have received your message and will respond soon');
          this.closeModal();
        });
    },
  }
};
</script>

<style lang="scss" scoped>
.fadeIn {
  animation-duration: 500ms;
}
.fadeInUp {
  animation-duration: 500ms;
}
.modal-card-body {
  p {
    text-align: center;
  }
}
.full {
  width: 100%;
}
textarea {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// support-form-modal.vue?240777d6